import React, { useState } from 'react';
import axios from 'axios';
import { useInView } from './useInView';
import './Contact.css';

export default function Contact() {
  const [ref, visible] = useInView();
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState(null); // null | 'loading' | 'success' | 'error'

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    try {
      await axios.post('/api/contact', form);
      setStatus('success');
      setForm({ name: '', email: '', message: '' });
    } catch {
      setStatus('error');
    }
  };

  return (
    <section className="section" id="contact">
      <div ref={ref} className={`fade-in${visible ? ' visible' : ''}`}>
        <p className="section-label">Contact</p>
        <h2 className="section-title">Let's work together.</h2>
        <div className="contact-layout">
          <div className="contact-left">
            <p className="contact-text">
              I'm actively looking for new opportunities. Whether you have a question, a project idea, or just want to say hello — my inbox is always open.
            </p>
            <div className="contact-links">
              <a href="mailto:nikhilvinchurkar070@gmail.com" className="contact-link">
                <span className="link-icon">✉️</span>
                <div>
                  <div className="link-label">Email</div>
                  <div className="link-value">nikhilvinchurkar070@gmail.com</div>
                </div>
              </a>
              <a href="https://linkedin.com/in/nikhil-vinchurkar0667" target="_blank" rel="noreferrer" className="contact-link">
                <span className="link-icon">🔗</span>
                <div>
                  <div className="link-label">LinkedIn</div>
                  <div className="link-value">nikhil-vinchurkar0667</div>
                </div>
              </a>
              <a href="https://github.com/Nikhil-Vin" target="_blank" rel="noreferrer" className="contact-link">
                <span className="link-icon">🐱</span>
                <div>
                  <div className="link-label">GitHub</div>
                  <div className="link-value">Nikhil-Vin</div>
                </div>
              </a>
              <a href="tel:+919689188969" className="contact-link">
                <span className="link-icon">📞</span>
                <div>
                  <div className="link-label">Phone</div>
                  <div className="link-value">+91 9689188969</div>
                </div>
              </a>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Name</label>
                <input
                  type="text" name="name" value={form.name}
                  onChange={handleChange} required placeholder="Your name"
                />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email" name="email" value={form.email}
                  onChange={handleChange} required placeholder="your@email.com"
                />
              </div>
            </div>
            <div className="form-group">
              <label>Message</label>
              <textarea
                name="message" value={form.message}
                onChange={handleChange} required
                placeholder="Tell me about your project..."
                rows={5}
              />
            </div>
            <button type="submit" className="submit-btn" disabled={status === 'loading'}>
              {status === 'loading' ? 'Sending...' : 'Send Message →'}
            </button>
            {status === 'success' && (
              <div className="form-feedback success">Message sent! I'll get back to you soon. ✓</div>
            )}
            {status === 'error' && (
              <div className="form-feedback error">Something went wrong. Please try again or email me directly.</div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}
